import { Navbar } from "../NavBar/NavBar";
import { AboutUsBaner } from "./Baners/AboutUsBaner";
import { TranslationServices } from "./TranslationServices/TranslationServices";
import { LatestPost } from "./LatestPosts/LatestPosts";
import { LinguisticServices } from "./LinguisticServies/LinguisticServies";
import { Heading } from "./Heading/Heading";
import { AnalysisServices } from "./analysisServices/AnalysisServices";
import { LanguageCourses } from "./languageCourses/LanguageCourses";
import { OurServices } from "./ourServices/OurServices";
import { Footer } from "../Footer/Footer";
import { AboutUs } from "./AboutUs/AboutUs";

export const HomePage = () => {
    return (
        <>
            <Navbar />
            <div className="homepage">
                <Heading />
                <LatestPost />
                <AboutUs />
                <LinguisticServices />
                <TranslationServices />
                <AboutUsBaner />
                <OurServices />
                <AnalysisServices />
                <LanguageCourses />
                <Footer />
            </div>
        </>
    );
};
